module.exports = __webpack_public_path__ + "static/media/icomanual_usuario_gris.9bd35bce.svg";